import { Avatar, useTheme } from '@mui/material';
import { useNetwork } from 'ahooks';
import { constSelector, useRecoilValue } from 'recoil';

import { selectUserImage, selectUserName } from 'state/signInRecoilState';

function UserAvatar() {
  const theme = useTheme();

  const isOnline = useNetwork().online;
  const userName = useRecoilValue(
    isOnline ? selectUserName : constSelector('')
  );
  const userImage = useRecoilValue(
    isOnline ? selectUserImage : constSelector('')
  );

  return (
    <Avatar
      alt={userName ?? ''}
      src={userImage ?? ''}
      style={{
        height: theme.spacing(3),
        width: theme.spacing(3),
      }}
    ></Avatar>
  );
}

export default UserAvatar;
